import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      setError("No session information found.");
      return;
    }
    (async () => {
      try {
        await api.post("/auth/session", { session_id: sessionId }, { withCredentials: true });
        toast.success("Signed in successfully");
        // Clear hash and go to home
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        setError("Could not complete sign-in. Please try again.");
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#101827] text-white flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        <div className="w-12 h-12 rounded-full border-2 border-[#C5A46D] border-t-transparent animate-spin mx-auto mb-6" />
        <h1 className="font-display text-2xl font-semibold mb-2">
          {error ? "Sign-in failed" : "Completing sign-in..."}
        </h1>
        <p className="text-white/70 text-sm">{error || "One moment while we securely log you in."}</p>
        {error && (
          <Link to="/" className="ae-btn-gold mt-6 inline-flex">Back to Home</Link>
        )}
      </div>
    </div>
  );
}
